import React from 'react';
import axios from './Api'
import { v4 as uuidv4 } from "uuid";

const defaultHeaders = {
    "Content-Type": "*/*;application/json",
    //"Accept" : "*/*;application/json",
    "X-Request-ID": uuidv4()
};

// export const BASE_APP_URL = `${window.location.protocol}//${window.location.hostname}:21000/api/`;
const gBackendHasBasicAuth = true

if (gBackendHasBasicAuth) {
    //let username = "saasuser";
    //let passwd = "spaceBar432!";
    //let credentials = btoa(username + ":" + passwd);
    //defaultHeaders["Authorization"] = "Basic " + credentials;

    let credentials = sessionStorage.getItem("authentication");
    defaultHeaders["Authorization"] = `Bearer ${credentials}`;
}

// axiosWrapper.js
export async function axiosWrapper(config) {
    try {
        return await axios(config);
    } catch (error) {
        let isHtmlError =
            error?.response?.data?.message?.includes('html') ||
            (typeof error?.response?.data === 'string' && error?.response?.data.includes('html'));
        let message =
            typeof error?.response?.data === 'string'
                ? error?.response?.data
                : error?.response?.data?.message || 'Something went wrong on the server. Please try again later.';

        if (error?.response?.data?.message) {
            return Promise.reject({
                ...error,
                response: {
                    ...error?.response,
                    data: {
                        ...error?.response?.data,
                        message: isHtmlError
                            ? "Something went wrong on the server. Please try again later."
                            : message
                    }
                }
            });
        } else {
            return Promise.reject({
                ...error,
                response: {
                    ...error?.response,
                    data: isHtmlError
                        ? "Something went wrong on the server. Please try again later."
                        : message
                }
            });
        }
    }
}


export default class ApiService extends React.Component {

    static async get(url, headers, data) {
        let credentials = sessionStorage.getItem("authentication");
        defaultHeaders["Authorization"] = `Bearer ${credentials}`;
        headers = Object.assign({}, defaultHeaders, headers);
        return await axiosWrapper({
            method: "GET",
            url: url,
            headers: headers,
            data: data,
            timeout: 3600000 // 1 hour in milliseconds
        });
    }

    static async prediction(url, headers, data) {
        let credentials = sessionStorage.getItem("authentication");
        defaultHeaders["Authorization"] = `Bearer ${credentials}`;
        headers = Object.assign({}, defaultHeaders, headers);
        return await axiosWrapper({
            method: "GET",
            url: url,
            headers: headers,
            data: data,
            timeout: 3600000,  // 20 minutes in milliseconds
            timeoutErrorMessage: "Request timed out",  // Optional: Custom error message
        })
    }


    static async fetch(url, headers) {
        let credentials = sessionStorage.getItem("authentication");

        defaultHeaders["Authorization"] = `Bearer ${credentials}`;
        headers = Object.assign({}, defaultHeaders, headers);

        return await axiosWrapper({
            method: "GET",
            url: url,
            headers: headers,
            timeout: 3600000,
            // withCredentials : withCredentialsFlag
        });

    }

    static async post(url, body, headers) {
        let credentials = sessionStorage.getItem("authentication");

        defaultHeaders["Authorization"] = `Bearer ${credentials}`;
        headers = Object.assign({}, defaultHeaders, headers);

        // Check if body is FormData
        const isFormData = body instanceof FormData;

        return await axiosWrapper({
            method: "POST",
            url: url,
            data: isFormData ? body : JSON.stringify(body),
            headers: isFormData ? { Authorization: `Bearer ${credentials}` } : headers,
            timeout: 3600000,
        });
    }

    static async getBlob(url, headers, data) {
        let credentials = sessionStorage.getItem("authentication");
        defaultHeaders["Authorization"] = `Bearer ${credentials}`;
        headers = Object.assign({}, defaultHeaders, headers);
        return await axiosWrapper({
            method: "GET",
            url: url,
            headers: headers,
            data: data,
            timeout: 3600000,
            responseType: 'blob'
        })
    }

    static async Login(url, body) {

        let headers = {
            "Content-type": "application/x-www-form-urlencoded"
        }
        return await axiosWrapper({
            method: "POST",
            url: url,
            data: body,
            headers: headers,
            timeout: 3600000,
        });
    }

    static async put(url, body) {
        let credentials = sessionStorage.getItem("authentication");

        defaultHeaders["Authorization"] = `Bearer ${credentials}`;
        let headers = Object.assign({}, defaultHeaders);

        return await axiosWrapper({
            method: "PUT",
            url: url,
            data: body,
            headers: headers,
            timeout: 3600000
        })

    }

    static async delete(url, body) {
        let credentials = sessionStorage.getItem("authentication");

        defaultHeaders["Authorization"] = `Bearer ${credentials}`;
        let headers = Object.assign({}, defaultHeaders);

        return await axiosWrapper({
            method: "DELETE",
            url: url,
            data: body ? JSON.stringify(body) : undefined,
            headers: headers,
            timeout: 3600000
        })
    }

    static async patch(url, body, headers) {

        let credentials = sessionStorage.getItem("authentication");
        defaultHeaders["Authorization"] = `Bearer ${credentials}`;
        headers = Object.assign({}, defaultHeaders, headers);

        return await axiosWrapper({
            method: "PATCH",
            url: url,
            data: body,
            headers: headers,
            timeout: 3600000
        });
    }

    static async upload(url, body, headers) {
        let credentials = sessionStorage.getItem("authentication");

        defaultHeaders["Authorization"] = `Bearer ${credentials}`;

        headers = Object.assign({}, defaultHeaders, headers);

        return await axiosWrapper({
            method: "POST",
            url: url,
            data: body,
            headers: headers,
            timeout: 3600000,
        });
    }

    static async uploadFormData(url, formData, headers = {}) {
        let credentials = sessionStorage.getItem("authentication");

        const formDataHeaders = {
            "Authorization": `Bearer ${credentials}`,
            ...headers,
        };

        return await axiosWrapper({
            method: "POST",
            url: url,
            data: formData,
            headers: formDataHeaders,
            timeout: 3600000,
        });
    }

    render() {
        return (null);
    }
}